import { api } from 'app/api';
import { ApiResponse, UserDto } from 'dtos';

export const getUsers = async (): Promise<ApiResponse<UserDto[]>> =>
  await api.get('users').then(res => res.data);
